export default __webpack_public_path__ + "static/media/events.825d4d93.svg";